import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { formatUsPhoneInputDigits } from '../../utilities/phone.utility';

/** Keeps the national number in ngx-intl-tel-input as xxx-xxx-xxxx while typing. */
@Directive({
  selector: 'ngx-intl-tel-input[appUsPhoneFormat]',
  standalone: false,
})
export class UsPhoneFormatDirective implements AfterViewInit, OnDestroy {
  private input?: HTMLInputElement;
  private teardown?: () => void;

  constructor(private readonly host: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    setTimeout(() => this.bindInput(), 0);
  }

  ngOnDestroy(): void {
    this.teardown?.();
  }

  private bindInput(): void {
    const input = this.host.nativeElement.querySelector('input.iti__tel-input');
    if (!(input instanceof HTMLInputElement)) return;
    this.input = input;

    const onInput = () => this.applyFormat();
    const onBlur = () => this.applyFormat();

    this.input.addEventListener('input', onInput);
    this.input.addEventListener('blur', onBlur);
    this.applyFormat();

    this.teardown = () => {
      this.input?.removeEventListener('input', onInput);
      this.input?.removeEventListener('blur', onBlur);
    };
  }

  private applyFormat(): void {
    if (!this.input) return;

    const digits = this.input.value.replace(/\D/g, '');
    if (!digits) return;

    const formatted = formatUsPhoneInputDigits(digits);
    if (this.input.value === formatted) return;

    const end = formatted.length;
    this.input.value = formatted;
    this.input.setSelectionRange(end, end);
  }
}
